module.exports = __webpack_public_path__ + "img/artinfo.2a9e8d2f.png";